import React from 'react';
import { ReactComponent as SuccessIcon } from 'images/new-icons/check-mark-blue.svg';
import Button from 'components/shared/Button';

const SuccessBooking = ({ onNext }) => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 24,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 24,
        }}
      >
        <SuccessIcon />
        <div
          style={{
            fontSize: 24,
            fontWeight: 700,
            fontFamily: 'Graphik Bold',
            width: 220,
            textAlign: 'center',
          }}
        >
          Your request is under review.
        </div>
      </div>
      <Button wide darkGreen onClick={onNext}>
        Back to shopping
      </Button>
    </div>
  );
};

export default SuccessBooking;
